import { render, staticRenderFns } from "./IconTypeAudio.vue?vue&type=template&id=9d837054&scoped=true"
import script from "./IconTypeAudio.vue?vue&type=script&lang=js"
export * from "./IconTypeAudio.vue?vue&type=script&lang=js"
import style0 from "./IconTypeAudio.vue?vue&type=style&index=0&id=9d837054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d837054",
  null
  
)

export default component.exports